import Rive from '@rive-app/react-canvas';
import React from 'react';

import { Images } from '@/components';
import { useRouter } from '@/provider/RouterProvider';
import { isRivFile } from '@/utils';
import { currencyFormatter } from '@/utils/currency';

const CardCollection: React.FC<{
  image: string;
  name: string;
  totalItem: number;
  tradingVolume: number;
  collectionId: number;
  className?: string;
}> = ({ image, tradingVolume, name, totalItem, collectionId, className = '' }) => {
  const router = useRouter();

  return (
    <div
      onClick={() => router.push(`/collection/${collectionId}`)}
      className={`group relative mb-[20px] h-[370px] w-full cursor-pointer overflow-hidden rounded-[24px] p-[16px] ${className}`}
    >
      <div className="absolute left-0 top-0 z-[1] h-full w-full">
        {isRivFile(image ?? '') ? (
          <Rive src={image} stateMachines="state-machine" />
        ) : (
          <Images
            src={image}
            className="h-full w-full object-cover duration-1000 group-hover:scale-[1.15]"
            alt="collection"
          />
        )}
      </div>
      <div style={{ background: 'linear-gradient(180deg,#080b0d00 50%,#080b0d99 99.99%,#14141499)' }} className="absolute left-0 bottom-0 z-[2] h-full w-full" />
      <div className="relative z-[2] flex h-full flex-col justify-end">
        <div className="mb-2">
          <h4 className="line-clamp-1 text-[19px] font-medium text-white lg:text-[16px]">{name}</h4>
        </div>
        <div className="flex items-center justify-between text-white text-[13px]">
          <div className="flex items-center rounded-lg gap-2 backdrop-blur-[24px] px-2 py-1 bg-[#ffffff26] whitespace-nowrap">
            <p className="font-light text-[12px]">Volume</p>
            <p className="font-semibold">{currencyFormatter(tradingVolume, { significantDigits: 3 })}</p>
          </div>
          <div className="flex items-center rounded-lg gap-2 backdrop-blur-[24px] px-2 py-1 bg-[#ffffff26] whitespace-nowrap">
            <p className="font-light text-[12px]">Items</p>
            <p className="font-semibold">{totalItem}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardCollection;
